// import React, { useState, useEffect } from "react";
// import { Heart, Loader2 } from "lucide-react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../utils/CartContext";
// import { useTranslation } from "react-i18next";

// const WishList = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [loadingCart, setLoadingCart] = useState(new Set());
//   const [loadingHeart, setLoadingHeart] = useState(new Set());
//   const navigate = useNavigate();
//   const { fetchCartCount } = useCart();
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   const getUserData = () => {
//     const userData = localStorage.getItem("pm-user-data");
//     return userData ? JSON.parse(userData) : null;
//   };

//   useEffect(() => {
//     AOS.init({ duration: 800, easing: "ease-out", once: true });
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   const isUserLoggedIn = () => !!localStorage.getItem("pm-user-data");

//   useEffect(() => {
//     if (isUserLoggedIn()) fetchWishlist();
//     else setLoading(false);
//   }, []);

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     // If value is a string (backward compatibility)
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     // If value is an object with language keys
//     if (typeof item[field] === 'object') {
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   // Fetch Wishlist
//   const fetchWishlist = async () => {
//     try {
//       setLoading(true);
//       const user = getUserData();
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${user._id}`
//       );
      
//       // Ensure products array exists
//       const productsData = response.data?.products || [];
      
//       // Add localized name to each product
//       const productsWithLocalizedNames = productsData.map(product => ({
//         ...product,
//         localizedName: getLocalizedText(product, "name")
//       }));
      
//       setProducts(productsWithLocalizedNames);
//     } catch (err) {
//       console.error("Error fetching wishlist:", err);
//       setError(t("failed_to_load_wishlist") || "Failed to load wishlist. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Remove from Wishlist (with loader)
//   const removeFromWishlist = async (productId) => {
//     if (!isUserLoggedIn()) {
//       toast.error(t("please_login") || "Please log in to manage wishlist");
//       return;
//     }

//     setLoadingHeart((prev) => new Set([...prev, productId]));
//     const user = getUserData();

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`,
//         { userId: user._id, productId },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       setProducts((prev) => prev.filter((p) => p._id !== productId));
//       toast.success(t("removed_from_wishlist") || "Removed from wishlist ❤️");
//     } catch (err) {
//       console.error("Error removing from wishlist:", err);
//       toast.error(t("failed_to_remove") || "Failed to remove item");
//     } finally {
//       setLoadingHeart((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(productId);
//         return newSet;
//       });
//     }
//   };

//   // Add to Cart (with loader)
//   const handleAddToCart = async (productId, quantity = 1) => {
//     if (!isUserLoggedIn()) {
//       toast.error(t("please_login_cart") || "Please log in to add items to your cart 🛒");
//       return;
//     }

//     setLoadingCart((prev) => new Set([...prev, productId]));
//     const user = getUserData();

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}/cart/add-product-to-cart`,
//         { userId: user._id, productId, quantity },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       toast.success(t("added_to_cart") || "Added to cart!");
//       fetchCartCount();
//     } catch (err) {
//       console.error("Error adding to cart:", err);
//       toast.error(t("failed_to_add_cart") || "Failed to add to cart");
//     } finally {
//       setLoadingCart((prev) => {
//         const newSet = new Set(prev);
//         newSet.delete(productId);
//         return newSet;
//       });
//     }
//   };

//   // Update product names when language changes
//   useEffect(() => {
//     if (products.length > 0) {
//       const updatedProducts = products.map(product => ({
//         ...product,
//         localizedName: getLocalizedText(product, "name")
//       }));
//       setProducts(updatedProducts);
//     }
//   }, [currentLanguage]);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50">
//         <div className="animate-spin w-10 h-10 border-4 border-gray-300 border-t-gray-900 rounded-full"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-50">
//         <h2 className="text-xl text-red-500 mb-2">{error}</h2>
//         <button
//           onClick={fetchWishlist}
//           className="bg-gray-900 text-white px-6 py-3 rounded-lg hover:bg-gray-800"
//         >
//           {t("try_again") || "Try Again"}
//         </button>
//       </div>
//     );
//   }

//   if (!isUserLoggedIn()) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center">
//         <div className="w-20 h-20 bg-red-50 flex items-center justify-center rounded-full mb-4">
//           <Heart className="w-10 h-10 text-red-500" />
//         </div>
//         <h2 className="text-2xl font-bold text-gray-900 mb-3">
//           {t("login_to_view_wishlist") || "Login to View Wishlist"}
//         </h2>
//         <p className="text-gray-600 mb-6">
//           {t("wishlist_login_message") || "Please log in to see your saved items."}
//         </p>
//         <button
//           onClick={() => navigate("/login")}
//           className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-lg transition duration-200 font-medium"
//         >
//           {t("login") || "Login"}
//         </button>
//       </div>
//     );
//   }

//   if (products.length === 0) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center">
//         <div className="w-20 h-20 bg-red-50 flex items-center justify-center rounded-full mb-4">
//           <Heart className="w-10 h-10 text-red-500" />
//         </div>
//         <h2 className="text-2xl font-bold text-gray-900 mb-3">
//           {t("wishlist_empty") || "Your wishlist is empty"}
//         </h2>
//         <p className="text-gray-600 mb-6">
//           {t("wishlist_empty_message") || "Start adding products you love by clicking the heart icon on product pages."}
//         </p>
//         <a
//           href="/"
//           className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-lg transition duration-200 font-medium"
//         >
//           {t("browse_products") || "Browse Products"}
//         </a>
//       </div>
//     );
//   }

//   return (
//     <div className="py-10 bg-[#FBFBFB] px-4 md:px-10">
//       <div className="container mx-auto">
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-10">
//           <h1 className="text-3xl md:text-4xl font-philosopher text-gray-900">
//             {t("your_wishlist") || "Your Wishlist"}
//           </h1>
//           <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">
//             {products.length} {products.length === 1 ? t("item") || "Item" : t("items") || "Items"}
//           </span>
//         </div>

//         {/* Product Cards */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
//           {products.map((product) => {
//             const isHeartLoading = loadingHeart.has(product._id);
//             const isAdding = loadingCart.has(product._id);
//             const productName = product.localizedName || getLocalizedText(product, "name") || product?.name || t("untitled_product");
//             const productImage = product.images?.[0] || "https://via.placeholder.com/300x300?text=Product+Image";

//             return (
//               <div
//                 key={product._id}
//                 className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden flex flex-col group transform hover:-translate-y-2 relative"
//                 data-aos="fade-up"
//               >
//                 {/* ❤️ Heart Button */}
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     removeFromWishlist(product._id);
//                   }}
//                   className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white shadow-md hover:bg-gray-100 transition-all duration-300"
//                   disabled={isHeartLoading}
//                   aria-label={t("remove_from_wishlist") || "Remove from wishlist"}
//                 >
//                   {isHeartLoading ? (
//                     <Loader2 className="w-5 h-5 text-red-500 animate-spin" />
//                   ) : (
//                     <Heart className="w-5 h-5 fill-red-500 stroke-red-500 transition-all duration-300" />
//                   )}
//                 </button>

//                 {/* 🖼 Product Image */}
//                 <div
//                   className="relative h-[320px] flex items-center justify-center overflow-hidden bg-white cursor-pointer"
//                   onClick={() => navigate(`/user-product-details/${product._id}`)}
//                   role="button"
//                   tabIndex={0}
//                   onKeyDown={(e) => e.key === 'Enter' && navigate(`/user-product-details/${product._id}`)}
//                 >
//                   <img
//                     src={productImage}
//                     alt={productName}
//                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                     onError={(e) => {
//                       e.target.src = "https://via.placeholder.com/300x300?text=Product+Image";
//                     }}
//                   />
//                 </div>

//                 {/* 📦 Info */}
//                 <div className="p-5 flex flex-col flex-grow">
//                   <h4
//                     className="font-medium text-sm mb-2 text-gray-900 group-hover:text-blue-600 transition line-clamp-2 h-[40px] cursor-pointer"
//                     onClick={() => navigate(`/user-product-details/${product._id}`)}
//                     role="button"
//                     tabIndex={0}
//                     onKeyDown={(e) => e.key === 'Enter' && navigate(`/user-product-details/${product._id}`)}
//                   >
//                     {productName}
//                   </h4>

//                   {/* Product Rating */}
//                   {product.ratings && (
//                     <div className="flex items-center mb-3">
//                       <div className="flex text-yellow-400">
//                         {[...Array(5)].map((_, i) => (
//                           <span key={i} className={i < Math.floor(product.ratings) ? "text-yellow-400" : "text-gray-300"}>
//                             ★
//                           </span>
//                         ))}
//                       </div>
//                       <span className="text-sm text-gray-600 ml-2">
//                         ({product.ratings})
//                       </span>
//                     </div>
//                   )}

//                   <div className="flex items-center gap-2 mt-auto mb-3">
//                     {product.previous_price && product.previous_price > product.price && (
//                       <span className="text-gray-400 line-through text-sm">
//                         ₹{product.previous_price}
//                       </span>
//                     )}
//                     <span className="text-xl font-bold text-orange-500">
//                       ₹{product.price}
//                     </span>
//                   </div>

//                   <button
//                     onClick={() => handleAddToCart(product._id)}
//                     disabled={isAdding}
//                     className="w-full bg-white border-2 border-gray-900 text-gray-900 py-2.5 text-sm font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
//                   >
//                     {isAdding ? (
//                       <div className="flex items-center justify-center gap-2">
//                         <Loader2 className="w-4 h-4 animate-spin" /> {t("adding") || "Adding..."}
//                       </div>
//                     ) : (
//                       t("quick_add") || "QUICK ADD"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default WishList;








import React, { useState, useEffect } from "react";
import { Heart, Loader2 } from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../utils/CartContext";
import { useTranslation } from "react-i18next";
import GuestSession from "../../utils/guestSession";

const WishList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loadingCart, setLoadingCart] = useState(new Set());
  const [loadingHeart, setLoadingHeart] = useState(new Set());
  const [isGuestMode, setIsGuestMode] = useState(false);
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const getUserData = () => {
    const userData = localStorage.getItem("pm-user-data");
    return userData ? JSON.parse(userData) : null;
  };

  const isUserLoggedIn = () => !!localStorage.getItem("pm-user-data");

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out", once: true });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    if (typeof item[field] === 'object') {
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  // Fetch wishlist from API for logged in user
  const fetchWishlistFromAPI = async () => {
    try {
      const user = getUserData();
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${user._id}`
      );
      
      const productsData = response.data?.products || [];
      
      const productsWithLocalizedNames = productsData.map(product => ({
        ...product,
        localizedName: getLocalizedText(product, "name")
      }));
      
      return productsWithLocalizedNames;
    } catch (err) {
      console.error("Error fetching wishlist from API:", err);
      return [];
    }
  };

  // Fetch wishlist from localStorage for guest
  const fetchWishlistFromLocalStorage = () => {
    try {
      const guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
      return guestWishlist;
    } catch {
      return [];
    }
  };

  // Fetch wishlist from localStorage by product IDs
  const fetchGuestWishlistProducts = async (productIds) => {
    if (productIds.length === 0) return [];
    
    try {
      // Fetch all products and filter by IDs in wishlist
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/get-all-products`
      );
      const allProducts = response.data?.products || [];
      
      // Filter products that are in wishlist
      const wishlistProducts = allProducts.filter(p => 
        productIds.includes(p._id.toString())
      );
      
      return wishlistProducts.map(product => ({
        ...product,
        localizedName: getLocalizedText(product, "name")
      }));
    } catch (err) {
      console.error("Error fetching guest wishlist products:", err);
      return [];
    }
  };

  // Main fetch wishlist function
  const fetchWishlist = async () => {
    try {
      setLoading(true);
      setError(null);
      
      if (isUserLoggedIn()) {
        // Logged in user - fetch from API
        setIsGuestMode(false);
        const products = await fetchWishlistFromAPI();
        setProducts(products);
      } else {
        // Guest user - fetch from localStorage
        setIsGuestMode(true);
        const guestProductIds = fetchWishlistFromLocalStorage();
        
        if (guestProductIds.length === 0) {
          setProducts([]);
        } else {
          const products = await fetchGuestWishlistProducts(guestProductIds);
          setProducts(products);
        }
      }
    } catch (err) {
      console.error("Error fetching wishlist:", err);
      setError(t("failed_to_load_wishlist") || "Failed to load wishlist. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Listen for guest wishlist updates
  useEffect(() => {
    const handleGuestWishlistUpdate = () => {
      if (!isUserLoggedIn()) {
        fetchWishlist();
      }
    };
    
    window.addEventListener('guest-wishlist-updated', handleGuestWishlistUpdate);
    return () => window.removeEventListener('guest-wishlist-updated', handleGuestWishlistUpdate);
  }, []);

  // Initial fetch
  useEffect(() => {
    fetchWishlist();
  }, []);

  // Remove from Wishlist
  const removeFromWishlist = async (productId) => {
    setLoadingHeart((prev) => new Set([...prev, productId]));

    try {
      if (isUserLoggedIn()) {
        // Logged in user - remove from API
        const user = getUserData();
        await axios.post(
          `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`,
          { userId: user._id, productId },
          { headers: { "Content-Type": "application/json" } }
        );
        setProducts((prev) => prev.filter((p) => p._id !== productId));
        toast.success(t("removed_from_wishlist") || "Removed from wishlist ❤️");
      } else {
        // Guest user - remove from localStorage
        let guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
        guestWishlist = guestWishlist.filter(id => id !== productId);
        localStorage.setItem('guestWishlist', JSON.stringify(guestWishlist));
        setProducts((prev) => prev.filter((p) => p._id !== productId));
        window.dispatchEvent(new Event('guest-wishlist-updated'));
        toast.success(t("removed_from_wishlist") || "Removed from wishlist ❤️");
      }
    } catch (err) {
      console.error("Error removing from wishlist:", err);
      toast.error(t("failed_to_remove") || "Failed to remove item");
    } finally {
      setLoadingHeart((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  // Add to Cart (works for both logged in and guest)
  const handleAddToCart = async (productId, quantity = 1) => {
    setLoadingCart((prev) => new Set([...prev, productId]));

    try {
      if (isUserLoggedIn()) {
        // Logged in user
        const user = getUserData();
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          { userId: user._id, productId, quantity },
          { headers: { "Content-Type": "application/json" } }
        );
      } else {
        // Guest user
        const guestId = GuestSession.getGuestId();
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          { guestId, productId, quantity },
          { headers: { "Content-Type": "application/json" } }
        );
      }
      toast.success(t("added_to_cart") || "Added to cart!");
      fetchCartCount();
    } catch (err) {
      console.error("Error adding to cart:", err);
      toast.error(t("failed_to_add_cart") || "Failed to add to cart");
    } finally {
      setLoadingCart((prev) => {
        const newSet = new Set(prev);
        newSet.delete(productId);
        return newSet;
      });
    }
  };

  // Update product names when language changes
  useEffect(() => {
    if (products.length > 0) {
      const updatedProducts = products.map(product => ({
        ...product,
        localizedName: getLocalizedText(product, "name")
      }));
      setProducts(updatedProducts);
    }
  }, [currentLanguage]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin w-10 h-10 border-4 border-gray-300 border-t-gray-900 rounded-full"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gray-50">
        <h2 className="text-xl text-red-500 mb-2">{error}</h2>
        <button
          onClick={fetchWishlist}
          className="bg-gray-900 text-white px-6 py-3 rounded-lg hover:bg-gray-800"
        >
          {t("try_again") || "Try Again"}
        </button>
      </div>
    );
  }

  // Show message when wishlist is empty
  if (products.length === 0) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
        <div className="w-20 h-20 bg-red-50 flex items-center justify-center rounded-full mb-4">
          <Heart className="w-10 h-10 text-red-500" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          {isGuestMode 
            ? t("guest_wishlist_empty") || "No items in your wishlist"
            : t("wishlist_empty") || "Your wishlist is empty"
          }
        </h2>
        <p className="text-gray-600 mb-6 max-w-md">
          {isGuestMode 
            ? t("guest_wishlist_empty_message") || "Start adding products you love by clicking the heart icon on product pages. Your items will be saved locally."
            : t("wishlist_empty_message") || "Start adding products you love by clicking the heart icon on product pages."
          }
        </p>
        {isGuestMode && (
          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg max-w-md">
            <p className="text-sm text-blue-700">
              {t("guest_wishlist_note") || "💡 Your wishlist is stored locally. Login to save your wishlist permanently and access it from any device."}
            </p>
          </div>
        )}
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="/"
            className="bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-lg transition duration-200 font-medium"
          >
            {t("browse_products") || "Browse Products"}
          </a>
          {isGuestMode && (
            <button
              onClick={() => navigate("/login")}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition duration-200 font-medium"
            >
              {t("login_to_save") || "Login to Save"}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-b from-orange-50 to-white pb-10 px-4 md:px-10">
      <div className="w-full mx-auto py-4">
        {/* Guest mode banner */}
        {/* {isGuestMode && (
          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div className="flex items-start gap-3">
              <div className="mt-1">
                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <p className="text-sm text-blue-800 font-medium">
                  {t("guest_wishlist_mode") || "Guest Wishlist"}
                </p>
                <p className="text-xs text-blue-600">
                  {t("guest_wishlist_mode_message") || "Your wishlist is stored locally. Login to save it permanently."}
                </p>
              </div>
            </div>
            <button
              onClick={() => navigate("/login")}
              className="whitespace-nowrap bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
            >
              {t("login_to_save") || "Login to Save"}
            </button>
          </div>
        )} */}

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4">
          <h1 className="text-3xl md:text-4xl font-philosopher text-gray-900">
            {t("your_wishlist") || "Your Wishlist"}
          </h1>
          <span className="bg-gray-100 text-gray-800 px-4 py-2 rounded-full text-sm font-medium">
            {products.length} {products.length === 1 ? t("item") || "Item" : t("items") || "Items"}
          </span>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 gap-2">
          {products.map((product) => {
            const isHeartLoading = loadingHeart.has(product._id);
            const isAdding = loadingCart.has(product._id);
            const productName = product.localizedName || getLocalizedText(product, "name") || product?.name || t("untitled_product");
            const productImage = product.images?.[0] || "https://via.placeholder.com/300x300?text=Product+Image";

            return (
              <div
                key={product._id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden flex flex-col group transform hover:-translate-y-2 relative"
                data-aos="fade-up"
              >
                {/* ❤️ Heart Button - Remove from wishlist */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    removeFromWishlist(product._id);
                  }}
                  className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white shadow-md hover:bg-gray-100 transition-all duration-300"
                  disabled={isHeartLoading}
                  aria-label={t("remove_from_wishlist") || "Remove from wishlist"}
                >
                  {isHeartLoading ? (
                    <Loader2 className="w-5 h-5 text-red-500 animate-spin" />
                  ) : (
                    <Heart className="w-5 h-5 fill-red-500 stroke-red-500 transition-all duration-300" />
                  )}
                </button>

                {/* 🖼 Product Image */}
                <div
                  className="relative h-[250px] flex items-center justify-center overflow-hidden bg-white cursor-pointer"
                  onClick={() => navigate(`/product-details/${product._id}`)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === 'Enter' && navigate(`/product-details/${product._id}`)}
                >
                  <img
                    src={productImage}
                    alt={productName}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/300x300?text=Product+Image";
                    }}
                  />
                </div>

                {/* 📦 Info */}
                <div className="p-5 flex flex-col flex-grow">
                  <h4
                    className="font-medium text-sm mb-2 text-gray-900 group-hover:text-blue-600 transition line-clamp-2 h-[40px] cursor-pointer"
                    onClick={() => navigate(`/product-details/${product._id}`)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && navigate(`/product-details/${product._id}`)}
                  >
                    {productName}
                  </h4>

                  {/* Product Rating */}
                  {product.ratings && (
                    <div className="flex items-center mb-3">
                      <div className="flex text-yellow-400">
                        {[...Array(5)].map((_, i) => (
                          <span key={i} className={i < Math.floor(product.ratings) ? "text-yellow-400" : "text-gray-300"}>
                            ★
                          </span>
                        ))}
                      </div>
                      <span className="text-sm text-gray-600 ml-2">
                        ({product.ratings})
                      </span>
                    </div>
                  )}

                  <div className="flex items-center gap-2 mt-auto mb-3">
                    {product.previous_price && product.previous_price > product.price && (
                      <span className="text-gray-400 line-through text-sm">
                        ₹{product.previous_price}
                      </span>
                    )}
                    <span className="text-xl font-bold text-orange-500">
                      ₹{product.price}
                    </span>
                  </div>

                  <button
                    onClick={() => handleAddToCart(product._id)}
                    disabled={isAdding}
                    className="w-full bg-white border-2 border-gray-900 text-gray-900 py-2.5 text-sm font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
                  >
                    {isAdding ? (
                      <div className="flex items-center justify-center gap-2">
                        <Loader2 className="w-4 h-4 animate-spin" /> {t("adding") || "Adding..."}
                      </div>
                    ) : (
                      t("quick_add") || "QUICK ADD"
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WishList;